<h2 class="sr-only">{{ "StandardSuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="standard" #form="ngForm">
  <h3 class="title-divider-suche">{{ "grundstueckHeading" | translate }}</h3>
  <cap-form-row class="mb-md-4" column-classes="col-md-2,col-md-4">
    <cap-form-control invalidKey="BauortMussVorhandenSein" labelKey="Bauort">
      <cap-bauort
        (blur)="onTouched()"
        (ngModelChange)="standard && (standard.bauortEntry = $event)"
        [hasfocus]="true"
        [ngModel]="standard && standard.bauortEntry"
        class="typeahead-holder"
        name="bauort"
        required></cap-bauort>
      <button (click)="emptyBauorteSearch()" class="btn btn-white" tabindex="-1" type="button">
        <span class="fas fa-times"></span>
      </button>
    </cap-form-control>
    <cap-form-control column-classes="col-md-1,col-md-1" invalidKey="EingabeMussValideGrundstueckNummerSein" labelKey="Nummer">
      <input
        (ngModelChange)="standard && (standard.grundstueckNummer = $event)"
        [ngModel]="standard && standard.grundstueckNummer"
        name="grundstueckNummer"
        size="6"
        type="text" />
    </cap-form-control>
  </cap-form-row>
  @if (searchForEgrid) {
    <cap-form-row class="mb-md-4 mt-md-2" column-classes="col-md-2,col-md-6">
      <cap-form-control invalidKey="EingabeMussValideEgridSein" labelKey="EGRID">
        <input
          (ngModelChange)="standard && standard.egrid && (standard.egrid.value = $event)"
          [ngModel]="standard && standard.egrid && standard.egrid.value"
          name="egrid.value"
          type="text" />
      </cap-form-control>
    </cap-form-row>
  }

  <div>
    <cap-form-row>
      <cap-projektstatus
        (ngModelChange)="standard && (standard.projektstatusSelection = $event)"
        [ngModel]="standard && standard.projektstatusSelection"
        class="col-md-4"
        name="projektstatusSelection"></cap-projektstatus>
      <div class="col-md-4">
        <h3 class="title-divider-suche col-md-12 ps-0">{{ "Baueingabe" | translate }}</h3>
        <cap-form-row>
          <cap-form-control column-classes="col-md-4,col-md-8" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="DatumVon">
            <cap-datepicker
              (ngModelChange)="standard && (standard.zeitrahmenVon = $event)"
              [ngModel]="standard && standard.zeitrahmenVon"
              class="p-0 border-0 ps-0"
              name="zeitrahmenVon"></cap-datepicker>
          </cap-form-control>
        </cap-form-row>
        <cap-form-row>
          <cap-form-control column-classes="col-md-4,col-md-8" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="DatumBis">
            <cap-datepicker
              (ngModelChange)="standard && (standard.zeitrahmenBis = $event)"
              [ngModel]="standard && standard.zeitrahmenBis"
              class="p-0 border-0 ps-0"
              name="zeitrahmenBis"></cap-datepicker>
          </cap-form-control>
        </cap-form-row>
      </div>
    </cap-form-row>
  </div>

  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">
        {{ "Zurücksetzen" | translate }}
      </button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
